export const AppConfig = {
  tokenKey: 'ap-token',
  roleKey: 'ap-user-role',
  apiUrl: `${import.meta.env.VITE_API_URL}`,
  aiServiceUrl: `${import.meta.env.VITE_AI_PYTHON_SERVICE_URL}`,
  aiServiceUrlOld: `${import.meta.env.VITE_AI_SERVICE_URL}`,
  blazeUrl: `${import.meta.env.VITE_BLAZE_URL}`,
  // Blaze/Hono read + write are skipped when VITE_BLAZE_URL is unset.
  isBlazeConfigured: !!import.meta.env.VITE_BLAZE_URL,
  mode: `${import.meta.env.VITE_MODE}`,
  region: `${import.meta.env.VITE_REGION}`,
  v2WebUrl: `${import.meta.env.VITE_WEB_URL}`.replace('https://v3-', 'https://'),
  // v2WebUrl: `http://localhost:3000`,
  webUrl: `${import.meta.env.VITE_WEB_URL}`, // TODO: Add eslint rule to check if import.meta.env.VITE_WEB_URL is used in the code
  wirisLatexToMathMLURL: `${import.meta.env.VITE_WIRIS_LATEX_TO_MATHML_URL}`,
  wirisMathMLToLatexURL: `${import.meta.env.VITE_WIRIS_MATHML_TO_LATEX_URL}`,
};

// True demo BUILD only (VITE_MODE exactly 'demo') — the one predicate under
// which demo-reset navigation may fire AND DemoMaintenancePage stays put.
// Both sides share it so the bar can never navigate somewhere the page bounces.
export const isDemoBuild = (): boolean => AppConfig.mode === 'demo';

/**
 * GLOBAL asset CDN — installers and `manual_uploads/*`. This is the host the
 * Rails uploader stamps onto the URLs it returns (its own `ENV["CDN_URL"]`),
 * so the two sides must agree per environment or a staging build hands out
 * production download links.
 *
 * China is NOT resolved here: that region has its own host
 * (`production-eks-assets.assessprep.cn`) and is selected by `region` inside
 * the download ladder, not by build mode.
 */
export const CDN_BASE_URL_GLOBAL = 'https://v2res1.assessprep.com';
export const CDN_BASE_URL_STAGING = 'https://v2res1-stag.assessprep.com';

/**
 * Which asset CDN a build talks to, by `VITE_MODE`.
 *
 *   production        -> global    (the live installers)
 *   demo              -> global    customer-facing; must serve the real signed
 *                                  artifacts, not whatever staging is testing
 *   china_production  -> global    inert — the China ladder never reads this
 *   staging           -> staging
 *   development(1)    -> staging   a dev build must not depend on a production
 *                                  upload having happened yet
 *   anything else     -> global    including unset and the test env: fall back
 *                                  to the real artifact rather than one that
 *                                  may not exist
 *
 * Pure + mode-in so the mapping is testable without a rebuild per environment.
 */
export const resolveCdnBaseUrl = (mode: string | undefined): string => {
  switch (mode) {
    case 'staging':
    case 'development':
    case 'development1':
      return CDN_BASE_URL_STAGING;
    default:
      return CDN_BASE_URL_GLOBAL;
  }
};

/** Resolved once at module load — `import.meta.env` is baked in at build time. */
export const cdnBaseUrl = resolveCdnBaseUrl(import.meta.env.VITE_MODE);
